<template>
  <div>
    <SysDialogFullScreen
      v-model="sys_dialog"
      titulo="Informações Adicionais"
      @click:hidden-dialog="fechar()"
    >
      <template #titulo-append>
        <v-spacer></v-spacer>

        <v-row>
          <div class="col pb-0 pt-5">
            <v-select
              v-model="itemForm.tipo_ajuste"
              :items="items_select"
              item-text="text"
              item-value="value"
              label="Tipo de Ajuste"
              dense
              dark
              clearable
              outlined
              @blur="atualizarTabelas()"
            ></v-select>
          </div>

          <div class="col pb-0 pt-5">
            <TextFieldFormatadorDeValor
              v-model="itemForm.porcentagem"
              label="Porcentagem"
              prefix="%"
              dense
              dark
              outlined
              @focus="$event.target.select()"
              @blur="atualizarTabelas()"
            ></TextFieldFormatadorDeValor>
          </div>

          <div class="col pb-0 pt-2 dark--text">
            <span class="font-14">Item recorrente?</span>

            <v-switch
              v-model="itemForm.recorrencia"
              dark
              inset
              dense
              hide-details
              class="py-0 my-0 mt-n1"
              color="primary"
              input-value="true"
              :title="itemForm.recorrencia ? 'Sim': 'Não'"
              :label="itemForm.recorrencia ? 'Sim': 'Não'"
            ></v-switch>
          </div>
        </v-row>

      </template>

      <template #titulo-parte-direita>
        <v-btn
          dark
          color="primary"
          @click="salvar()"
        >
          <v-icon>mdi-save</v-icon> Salvar
        </v-btn>
      </template>

      <div class="row pa-0 ma-0">
        <div
          class="col-6"
        >
          <sys-data-table
            v-model="produtos_selecionados_tabela"
            :headers="headers_data"
            :items="array_multi_datas"
            :height="alturaDaJanela - 150"
            :item-height="25"
            hide-default-footer
            class="elevation-1"
          >
            <template #top>
              <v-toolbar flat color="white">
                <v-spacer></v-spacer>

                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-click="false"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  max-width="450"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="dates"
                      multiple
                      chips
                      dense
                      outlined
                      small-chips
                      label="Selecione o Periodo"
                      readonly
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="arrayMultiDatasErrors"
                      @input="$v.array_multi_datas.$touch()"
                      @blur="$v.array_multi_datas.$touch()"
                    ></v-combobox>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    range
                    no-title
                    scrollable
                    full-width
                    :max="momentNow"
                    :show-current="momentYearAgo"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="multiDatas()"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-toolbar>
            </template>

            <template #item.media_periodo="{ item }">
              <span v-if="produtosComputados.length == 1">{{ Helpers.formatarValorComCasas(item.media_periodo, 2) }}</span>
              <span v-else></span>
            </template>

            <template #item.aplicado="{ item }">
              <div class="row">
                <div class="my-auto">
                  <v-switch
                    v-model="item.aplicado"
                    title="Ativar ou desativar"
                    hide-details
                    class="pl-2"
                    @click="alterarStatusAplicado(item)"
                  ></v-switch>
                </div>
              </div>
            </template>

            <template #item.acoes="{ item }">
              <v-btn
                icon
                small
                title="Remover periodo"
                @click="removerDataDoArray(item)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </sys-data-table>
        </div>

        <div class="col-6" v-if="produtosComputados">
          <sys-data-table
            v-model="produtos_selecionados_tabela"
            :headers="headers_edited"
            :items="produtosComputados"
            :items-per-page="-1"
            item-key="idproduto"
            hide-default-footer
            :fixed-header="true"
            dense
            :height="alturaDaJanela - 85"
            :item-height="25"
            class="table-full-screen elevation-1"
          >
            <template #item.media="{ item }">
              {{ Helpers.formatarValorComCasas(item.media, 2) }}
            </template>

            <template #item.media_crescimento="{ item }">
              {{ Helpers.formatarValorComCasas(item.media_crescimento, 2) }}
            </template>
          </sys-data-table>
        </div>
      </div>

      <DialogError
        :dialog="dialog_error.dialog"
        :errors="dialog_error.errors"
        @fechar="dialog_error.dialog = false; dialog_error.errors = []; menu = true; dates = []"
      />
    </SysDialogFullScreen>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { required, requiredIf } from "vuelidate/lib/validators";
import Responsividade from '../../../../helpers/ResponsiveHeight';
import DialogError from "../../../../components/utils/DialogError.vue";
import moment from 'moment';
import SazonalidadeAPI from "../../../../api/sazonalidade";
import SysDialogFullScreen from "../../../padraoDeLayout/SysDialogFullScreen.vue";
import TextFieldFormatadorDeValor from "../../../utils/TextFieldFormatadorDeValor.vue";

export default {
  mixins: [Responsividade],
  components: {
    SysDialogFullScreen,
    TextFieldFormatadorDeValor,
    DialogError
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    produtos: {
      type: [Object, Array]
    },
    ids_fornecedores: {
      type: [Object, Array]
    },
    editedItem: {
      type: [Object, Array]
    },
    produto_selecionado_sigle: {
      type: [Object, Array]
    }
  },
  data () {
    return {
      sys_dialog: false,
      headers_data: [
        { text: 'Data Inicial', value: 'data_inicial'},
        { text: 'Data Final', value: 'data_final'},
        { text: 'Aplicado', value: 'aplicado'},
        { text: 'Media Periodo', value: 'media_periodo'},
        { text: 'Ações', value: 'acoes'}
      ],
      headers_edited: [
        { text: 'Id Produto', value: 'idproduto' },
        { text: 'Descrição', value: 'descricao_produto' },
        { text: 'Media Periodo', value: 'media' },
        { text: 'Porcentagem', value: 'porcentagem' },
        { text: 'Media Aplicada', value: 'media_crescimento' }
      ],
      desserts: [],
      menu: false,
      editando: false,
      dates: [],
      array_multi_datas: [],
      switch_periodo: false,
      itemForm: {
        tipo_ajuste: '',
        porcentagem: '',
        recorrencia: false
      },
      items_select: [
        { text: 'Aumento', value: '1'},
        { text: 'Redução', value: '0'}
      ],
      produtos_com_media : [],
      headers : [
        { text: 'ID Produto', value: 'idproduto' },
        { text: 'Descrição', value: 'descricao_produto' },
        { text: 'Media', value: 'media' }
      ],
      produtos_selecionados_tabela: [],
      dialog_error: {
        dialog: false,
        errors: []
      }
    }
  },
  validations: {
    array_multi_datas: {
      required: requiredIf(function (value) {
        return true;
      })
    }
  },
  computed: {
    ...mapGetters({
      grupo_id: "usuario/getGrupoCompras",
      getFornecedor: "fornecedor/getFornecedor",
      produtosSelecionadosVuex: "ProdutosSelecionados/getProdutosSelecionados",
      qtdeProdutosSelecionadosVuex: "ProdutosSelecionados/getQtdeProdutosSelecionados"
    }),

    momentNow() {
      return moment().format('YYYY-MM-DD');
    },

    momentYearAgo() {
      return moment().subtract(1, 'years').format('YYYY-MM-DD');
    },

    produtosComputados() {
      if (this.produtos_com_media && this.produtos_com_media.length > 0) {
        return this.produtos_com_media;
      } else if (this.produtos) {
        return this.produtos;
      } else {
        return [];
      }
    },

    arrayMultiDatasErrors() {
      const errors = [];
      if (!this.$v.array_multi_datas.$dirty) return errors;
      !this.$v.array_multi_datas.required && errors.push("Campo Obrigatório.");
      return errors;
    },

    tipoAjusteErrors() {
      const errors = [];
      if (!this.$v.itemForm.tipo_ajuste.$dirty) return errors;
      !this.$v.itemForm.tipo_ajuste.required && errors.push("Campo Obrigatório.");
      return errors;
    },

    porcentagemErrors() {
      const errors = [];
      if (!this.$v.itemForm.porcentagem.$dirty) return errors;
      !this.$v.itemForm.porcentagem.required && errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  watch: {
    dialog(val) {
      if (this.$route.path == '/compra' && val) {

        if (this.qtdeProdutosSelecionadosVuex == 1 || this.produtosComputados.length == 1) {
          this.getSazonalidadeSingleDialogPeriodo();
        }

        setTimeout(() => {
          this.sys_dialog = true;
        }, 1000);
      } else if (this.$route.path == '/produtos/sazonalidades' && val) {
        this.sys_dialog = true;

        let produt = [];

        if (this.produtos) {
          produt = this.produtos;
        } else if (this.editedItem) {
          produt = [this.editedItem];
        } else {
          produt = this.produtosComputados;
        }

        this.buscarDatasPeriodoProduto(produt);
      }
    },

    editedItem(val) {
      if (val.dia_mes_inicial != undefined) {
        this.editando = true;
        this.sys_dialog = true;

        this.buscarDatasPeriodoProduto(val.idproduto);

        this.itemForm = {
          fornecedores: val.fornecedor,
          grupo_id: this.grupo_id,
          filial: val.filial,
          idproduto: [val.idproduto],
          porcentagem: val.porcentagem,
          recorrencia: val.recorrencia == '1' ? true : false,
          tipo_ajuste: val.tipo_ajuste == '1' ? '1' : val.tipo_ajuste == '0' ? '0' : ''
        }
      }
    },

    array_multi_datas(value) {
      if (value.length > 0) {
        this.buscarMediaPeriodoSelecionado();
      }
    }
  },
  methods:{
    ...mapMutations({
      resetProdutosSelecionados: "ProdutosSelecionados/SET_RESET_PRODUTOS_SELECIONADOS",
      fecharDialogSazonalidade: "tabelaProduto/SET_FECHAR_DIALOG_SAZONALIDADE"
    }),

    atualizarTabelas() {
      if (this.array_multi_datas.length > 0) {
        this.buscarMediaPeriodoSelecionado();
        this.multiDatas();
      }
    },

    buscarMediaPeriodoSelecionado() {
      let produtos = [];
      let info = [];

      if (this.editedItem) {
        produtos = [this.editedItem];
      } else if (this.produtos.length == 1) {
        produtos = [{
          idproduto: this.produtos[0].idproduto,
          descricao_produto: this.produtos[0].descricao_produto,
          tipo_ajuste: this.itemForm.tipo_ajuste,
          porcentagem: this.itemForm.porcentagem,
          porcentagem_filial: this.itemForm.porcentagem
        }]
      } else {
        produtos = this.produtos;
      }

      info = {
        tipo_ajuste: this.itemForm.tipo_ajuste,
        porcentagem: this.itemForm.porcentagem,
        porcentagem_filial: this.itemForm.porcentagem
      }

      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        produto: produtos,
        datas: this.array_multi_datas,
        info: info
      };

      if ((this.editedItem || this.produtos) && this.array_multi_datas.length) {
        this.$store.dispatch("loading/addRequisicao",
          SazonalidadeAPI.buscarMediaPeriodoSelecionado(headers, params)
            .then((response) => {
              const { token, produtos_media } = response.data;
              localStorage.setItem("token", token);

              this.produtos_com_media = produtos_media;
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    getSazonalidadeSingleDialogPeriodo() {
      const headers = this.Helpers.iniciarRequisicao();
      if (this.produtos) {
        const params = {
          produto: this.produtos.map((item) => item.idproduto)
        };

        SazonalidadeAPI.getSazonalidadeSingleDialogPeriodo(headers, params)
          .then((response) => {
            const { token, produto_dialog } = response.data;
            localStorage.setItem("token", token);

            if (produto_dialog.length == 1) {
              this.buscarDatasPeriodoProduto(produto_dialog[0].idproduto);

              this.itemForm.porcentagem = produto_dialog[0].porcentagem;
              this.itemForm.recorrencia = produto_dialog[0].recorrencia == '1' ? true : false;
              this.itemForm.tipo_ajuste = produto_dialog[0].tipo_ajuste;
            }
          })
          .catch(() => { this.Helpers.logout(); })
      }
    },

    buscarDatasPeriodoProduto(id_produto) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        produto: id_produto
      };

      SazonalidadeAPI.buscarDatasPeriodoProduto(headers, params)
        .then((response) => {
          const { token, datas } = response.data;
          localStorage.setItem("token", token);

          this.converterDatas(datas);
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    converterDatas(datas) {
      this.array_multi_datas = [];

      datas.forEach(el => {
        this.array_multi_datas.push({
          data_inicial: el.data_inicial,
          data_final: el.data_final,
          media_periodo: el.media_periodo,
          aplicado: el.aplicado == '1' ? true : false
        });
      });
    },

    verificarMultiDatas() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = this.produtos;

      SazonalidadeAPI.verificarMultiDatas(headers, params)
        .then((response) => { localStorage.setItem("token", response.data.token); })
        .catch(() => { this.Helpers.logout(); })
    },

    emits() {
      this.$emit('fechar-dialog-editando');
      this.$emit('atualizar-data-table');
      this.$emit('reset-cadastro-sazonalidade');
    },

    fechar(param = false) {
      this.verificarMultiDatas();

      if (this.editando || param) {
        this.$emit('fechar-dialog-editando', true);
        this.$emit('atualizar-data-table');
      } else {
        this.$emit('fechar-dialog-editando', false);
      }

      this.$v.$reset();
      this.itemForm = {
        tipo_ajuste: '',
        porcentagem: '',
        recorrencia: false
      };
      this.array_multi_datas = [];
      this.produtos_com_media = [];
      this.editando = false;
      this.sys_dialog = false;
    },

    salvar() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = {
          id_grupo: this.grupo_id,
          fornecedores: this.ids_fornecedores ? this.ids_fornecedores : this.itemForm.fornecedores,
          idproduto: this.produtos ? this.produtos : this.itemForm.idproduto,
          filial: this.editedItem != undefined ? this.editedItem.filial : null,
          porcentagem: this.itemForm.porcentagem,
          recorrencia: this.itemForm.recorrencia,
          tipo_ajuste: this.itemForm.tipo_ajuste,
          todosProdutosDoFornecedor: false,
          show_multiplos_periodos: this.array_multi_datas
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          SazonalidadeAPI.storeSazonalidade(headers, params)
            .then((response) => {
              const { token } = response.data;
              localStorage.setItem("token", token);

              this.emits();
              this.fechar(true);
              this.resetProdutosSelecionados();
              this.fecharDialogSazonalidade();
            })
            .catch(() => { this.Helpers.logout(); })
        );
      }
    },

    removerDataDoArray(item) {
      let produtos_function = {
        idproduto: '',
        filial: '',
        periodos: item
      };

      if (this.editedItem) {
        produtos_function.filial = this.editedItem.filial;
        produtos_function.idproduto = this.editedItem.idproduto;
      } else {
        produtos_function.idproduto = this.produtosComputados[0].idproduto;
      }

      const headers = this.Helpers.iniciarRequisicao();
      const params = produtos_function;

      this.$store.dispatch(
        "loading/addRequisicao",
        SazonalidadeAPI.excluirDatasPeriodoProduto(headers, params)
          .then((response) => {
            const { token } = response.data;
            localStorage.setItem("token", token);

            this.array_multi_datas = this.array_multi_datas.filter((data) => JSON.stringify(data) != JSON.stringify(item));
          })
          .catch(() => { this.Helpers.logout(); })
      );
    },

    multiDatas() {
      let array_datas = [];

      this.dates.forEach(el => {
        const [year, month, day] = el.split('-');
        array_datas.push(`${day}/${month}/${year}`);
      });

      if (array_datas[0] < array_datas[1]) {
        let prod = '';

        if (this.editedItem) {
          prod = this.editedItem.idproduto;
        } else {
          prod = this.produtosComputados.length == 1 ? this.produtosComputados[0].idproduto : this.produtosComputados;
        }

        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          idproduto: prod,
          data_inicial: array_datas[0],
          data_final: array_datas[1]
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          SazonalidadeAPI.getMediaPeriodoData(headers, params)
            .then((response) => {
              const { token, media } = response.data;
              localStorage.setItem("token", token);

              let periodos = {
                data_inicial: array_datas[0],
                data_final: array_datas[1],
                aplicado: true,
                media_periodo: media
              }

              this.array_multi_datas.push(periodos);
            })
            .catch(() => { this.Helpers.logout(); })
        );
        this.menu = false;
      } else if (this.array_multi_datas.length == 0){
        this.dialog_error.dialog = true;
        this.dialog_error.errors.push('Datas informadas inválidas!');
      }
      this.dates = [];
    },

    alterarStatusAplicado(item) {
      let prod = '';
      if (this.editedItem) {
        prod = this.editedItem.idproduto;
      } else {
        prod = this.produtosComputados.length == 1 ? this.produtosComputados[0].idproduto : '';
      }

      item.idproduto = prod;
      item.tipo_ajuste = this.itemForm.tipo_ajuste;
      item.porcentagem = this.itemForm.porcentagem;

      const headers = this.Helpers.iniciarRequisicao();
      const params = item;

      this.$store.dispatch(
        "loading/addRequisicao",
        SazonalidadeAPI.alterarStatusAplicado(headers, params)
          .then((response) => {
            const { token } = response.data;
            localStorage.setItem("token", token);

            this.buscarDatasPeriodoProduto(prod);
          })
          .catch(() => { this.Helpers.logout(); })
      );
    }
  }
}
</script>

<style>

</style>
